import { useLocale } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

const SECTIONS = [
  { id: 'notice', title: 'Legal Notice' },
  { id: 'privacy', title: 'Privacy' },
  { id: 'cookies', title: 'Cookies' },
  { id: 'terms-use', title: 'Terms of Use' },
  { id: 'terms-service', title: 'Terms of Service' },
  { id: 'dpa', title: 'Data Processing Agreement' },
];

/* No legal copy exists in the source material (tools/content.py has no
 * authored Terms/Privacy/DPA text) — per the spec's own content model
 * (§24.1: legal pages "cannot publish without a named legal reviewer
 * sign-off"), this is deliberately NOT fabricated here. The page reads
 * from the CMS (page slug "legal") and shows each section honestly as
 * pending until real, reviewed legal copy is published. */
export default function Legal() {
  const locale = useLocale();
  const state = useApiData(() => contentApi.page('legal', locale), [locale]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <h1>Legal</h1>
        <AsyncSection
          state={state}
          emptyMessage="Legal copy for this site has not been published yet — it requires a named legal reviewer's sign-off before it can go live (see this project's IMPLEMENTATION_CHECKLIST.md)."
          render={(page) => <div>{JSON.stringify(page.contentBlocks)}</div>}
        />
        {SECTIONS.map((s) => (
          <div id={s.id} key={s.id} className="card reveal is-visible" style={{ marginTop: 24 }}>
            <h2>{s.title}</h2>
            <p className="body-sm">Pending publication — see above.</p>
          </div>
        ))}
      </div>
    </section>
  );
}
